import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectCustomersByFeedType } from 'redux/reducers/customers';
import { selectTopicFilters } from 'redux/reducers/topicFilters';
import getCustomerFilters from 'helpers/getCustomerFilters';
import { SalesTypeValues } from 'maps/sales-types';
import { TopicFilterNames } from 'components/TopicFilters/shared';

const filtersForSalesType: { [key: string]: TopicFilterNames[] } = {
  equivalents: [
    'country',
    'streaming',
    'download',
    'region',
    'media',
    'customRegion',
  ],
  streaming: ['country', 'streaming', 'region', 'media', 'customRegion'],
  downloads: ['country', 'download', 'region', 'media', 'customRegion'],
  physical: ['country', 'region', 'customRegion'],
};

const useListCustomerFilters = (
  salesType: SalesTypeValues
): [string[], string[]] => {
  const filters = useSelector(selectTopicFilters);
  const selectCustomers = useCallback(
    selectCustomersByFeedType(['streaming', 'downloads']),
    []
  );
  const customers = useSelector(selectCustomers);
  const allowedFilters = filtersForSalesType[salesType];

  const customerFilter =
    getCustomerFilters(customers, allowedFilters, filters) ?? [];

  return [allowedFilters, customerFilter];
};

export default useListCustomerFilters;
